import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Toast, ToastService } from '../../../services/toast.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-base-toast',
  templateUrl: './base-toast.component.html',
  styleUrls: ['./base-toast.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class BaseToastComponent implements OnInit, OnDestroy {
  @Input() maxToasts = 5;

  toasts: Toast[] = [];
  private toastSubscription?: Subscription;

  constructor(
    private toastService: ToastService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.toastSubscription = this.toastService.toasts$.subscribe((toasts) => {
      this.toasts = toasts.slice(-this.maxToasts);
    });
  }

  ngOnDestroy(): void {
    this.toastSubscription?.unsubscribe();
  }

  closeToast(id: string): void {
    this.toastService.remove(id);
  }

  handleAction(toast: Toast): void {
    if (toast.actionUrl) {
      this.router.navigate([toast.actionUrl]);
      this.closeToast(toast.id);
    }
  }

  getIcon(type: string): string {
    switch (type) {
      case 'success':
        return '✓';
      case 'error':
        return '✕';
      case 'warning':
        return '⚠';
      case 'info':
      case 'notification':
        return 'ℹ';
      default:
        return '';
    }
  }

  formatTime(dateString: string): string {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffMins = Math.floor(diffMs / 60000);

    if (diffMins < 1) return 'just now';
    if (diffMins < 60) return `${diffMins}m ago`;

    const diffHours = Math.floor(diffMins / 60);
    if (diffHours < 24) return `${diffHours}h ago`;

    const diffDays = Math.floor(diffHours / 24);
    return `${diffDays}d ago`;
  }
}
